import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/services/axios'
import router from '@/router'

import user from './user'
import settings from './settings'
import dashboard from './dashboard'
import channel from './channel'
import app from './app'
import data from './data'
import sales from './sales'
import account from './account'
import product from './product'
import storeSetting from './storeSetting'
import purchase from './purchase'
import { SET as SET_APP, FETCHED as APP_FETCHED } from './app/types'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    app,
    user,
    settings,
    dashboard,
    channel,
    data,
    sales,
    account,
    product,
    storeSetting,
    purchase,
  },
  state: {},
  mutations: {},
  actions: {
    async appClientInit({ commit, rootState }) {
      try {
        const { data: response } = await axios.get('/data/admin')
        const { message: data } = response

        commit(SET_APP, {
          title: data.logo_url,
          type: data.seller_type,
          name: data.vendor_name,
          id: data.vendor_hashid,
          logo: data.logo_url,
          withdraw_min_amount: data?.withdraw_min_amount ? data.withdraw_min_amount : 50000,
        })
      } catch (err) {
        router.push('/auth/404').catch(e => {})
      }

      commit(APP_FETCHED)
    },
  },
})
